<div id="app-wr" class="relative flex min-h-svh w-full" [attr.data-version]="portalVersion">

  <!-- sidebar -->
  <app-sidebar [displaySidebar]="displaySidebar" (closeSidebarEvent)="closeSidebar()"></app-sidebar>
  <div class="sidebar-overlay" [ngClass]="{ 'visible': isMobile && displaySidebar }" (click)="closeSidebar()"></div>
  <!-- /sidebar -->

  <div id="main-wr" class="flex flex-1 flex-col" [ngClass]="{'full-width': !displaySidebar, 'pl-64': !isMobile }">
    <main class="grow">
      <!-- topbar -->
      <app-header (sidebarStatusEvent)="toggleSidebar()"></app-header>

      <div id="main-content-wr">
        <router-outlet></router-outlet>
      </div>
    </main>
  </div>
</div>
